export default "__VITE_ASSET__d61f9e7d__"